import React from 'react';
// Components
import SetupAma from 'components/common/SetupAma/SetupAma';

const SetupAthleteAma: React.FC = () => {
  return <SetupAma />;
};

export default SetupAthleteAma;
